"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountyValueProvider = useCountyValueProvider;
const hooks_1 = require("../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
function useCountyValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const client = (0, hooks_1.usePublicDataClient)(params?.appName, params?.baseUrl);
    return {
        type: 'classifier.county',
        label: t('defaultClassifiers.county'),
        getValues: (params) => {
            if (typeof params === 'string') {
                return client.publicDataGetObject('classifier-county-' + params);
            }
            else {
                return Promise.resolve([]);
            }
        },
    };
}
